import PageWrapper from "../../components/PageWrapper";
export default function Management() {
  return <PageWrapper title="ریاست" subtitle="مدیریت و نظارت عالی سیستم" icon="👑" color="#f59e0b" />;
}